import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { PruHttpService } from '../services/pru-http.service';

@Injectable({
  providedIn: "root"
})
export class HtmlTextService {
  constructor(private PruHTTP: PruHttpService) {}

  /**
   *
   * @param serviceURL: serviceURL
   */
  getHTMLText(serviceURL: string): Observable<any> {
    return this.PruHTTP.getText(serviceURL, "HTMLTextService", {
      responseType: "text"
    });
  }
}
